/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineExtraStaysTotalDto } from './traveline-extra-stays-total-dto';
import {
    TravelineExtraStaysTotalDtoFromJSON,
    TravelineExtraStaysTotalDtoFromJSONTyped,
    TravelineExtraStaysTotalDtoToJSON,
    TravelineExtraStaysTotalDtoToJSONTyped,
} from './traveline-extra-stays-total-dto';

/**
 * 
 * @export
 * @interface TravelineExtraStayDetailsRsDto
 */
export interface TravelineExtraStayDetailsRsDto {
    /**
     * Date and property local time <br />
     * Date and time format complies with ISO-8601 YYYY-MM-DDThh:mm
     * @type {Date}
     * @memberof TravelineExtraStayDetailsRsDto
     */
    overriddenDateTime?: Date;
    /**
     * 
     * @type {TravelineExtraStaysTotalDto}
     * @memberof TravelineExtraStayDetailsRsDto
     */
    total?: TravelineExtraStaysTotalDto;
}

/**
 * Check if a given object implements the TravelineExtraStayDetailsRsDto interface.
 */
export function instanceOfTravelineExtraStayDetailsRsDto(value: object): value is TravelineExtraStayDetailsRsDto {
    return true;
}

export function TravelineExtraStayDetailsRsDtoFromJSON(json: any): TravelineExtraStayDetailsRsDto {
    return TravelineExtraStayDetailsRsDtoFromJSONTyped(json, false);
}

export function TravelineExtraStayDetailsRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineExtraStayDetailsRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'overriddenDateTime': json['overriddenDateTime'] == null ? undefined : (new Date(json['overriddenDateTime'])),
        'total': json['total'] == null ? undefined : TravelineExtraStaysTotalDtoFromJSON(json['total']),
    };
}

  export function TravelineExtraStayDetailsRsDtoToJSON(json: any): TravelineExtraStayDetailsRsDto {
      return TravelineExtraStayDetailsRsDtoToJSONTyped(json, false);
  }

  export function TravelineExtraStayDetailsRsDtoToJSONTyped(value?: TravelineExtraStayDetailsRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overriddenDateTime': value['overriddenDateTime'] == null ? undefined : ((value['overriddenDateTime']).toISOString()),
        'total': TravelineExtraStaysTotalDtoToJSON(value['total']),
    };
}

